"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElementErrorBoundary = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _DatadogErrorBoundary2 = require("./DatadogErrorBoundary");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _ElementErrorBoundary = require("./ElementErrorBoundary.styled");
var _Button = require("../Button");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ElementErrorBoundary = exports.ElementErrorBoundary = /*#__PURE__*/function (_DatadogErrorBoundary) {
  (0, _inherits2["default"])(ElementErrorBoundary, _DatadogErrorBoundary);
  var _super = _createSuper(ElementErrorBoundary);
  function ElementErrorBoundary(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ElementErrorBoundary);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onReload", function () {
      return _this.setState({
        hasError: false
      });
    });
    _this.state = {
      hasError: false
    };
    return _this;
  }
  (0, _createClass2["default"])(ElementErrorBoundary, [{
    key: "render",
    value: function render() {
      var iconMap = {
        info: _freeSolidSvgIcons.faInfoCircle,
        failure: _freeSolidSvgIcons.faExclamationTriangle
      };
      var _this$props = this.props,
        header = _this$props.header,
        description = _this$props.description,
        buttonText = _this$props.buttonText,
        iconType = _this$props.iconType,
        reloadIcon = _this$props.reloadIcon,
        reloadButtonPosition = _this$props.reloadButtonPosition,
        tooltipText = _this$props.tooltipText,
        tooltip = _this$props.tooltip,
        sectionTextAlign = _this$props.sectionTextAlign,
        sectionHeight = _this$props.sectionHeight,
        sectionWidth = _this$props.sectionWidth,
        sectionMargin = _this$props.sectionMargin,
        reloadAsLink = _this$props.reloadAsLink,
        _this$props$onReload = _this$props.onReload,
        onReload = _this$props$onReload === void 0 ? this.onReload : _this$props$onReload;
      var headerIconStyle = {
        color: '#9B2012',
        marginRight: !header && reloadButtonPosition !== 'right' ? '0px' : '8px'
      };
      var headerStyle = {
        margin: '0px',
        lineHeight: !header ? '16px' : '24px',
        textAlign: sectionTextAlign
      };
      var divStyle = {
        textAlign: reloadButtonPosition,
        marginTop: !header && !iconType ? '0px' : '8px'
      };
      var sectionStyle = {
        padding: sectionTextAlign === 'left' || reloadIcon ? '12px' : '20px',
        height: sectionHeight,
        width: sectionWidth,
        margin: sectionMargin,
        overflowWrap: 'break-word'
      };
      var buttonElementNode = getButtonElement(reloadIcon, buttonText, onReload);
      if (this.state.hasError) {
        return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_ElementErrorBoundary.DynamicErrorWrapper, {
          style: sectionStyle
        }, _react["default"].createElement("h1", {
          style: headerStyle
        }, _react["default"].createElement("span", {
          style: {
            verticalAlign: 'middle'
          }
        }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          style: headerIconStyle,
          icon: iconMap[iconType]
        }), header, reloadAsLink && getLinkElement(buttonText, header, onReload)), !reloadAsLink && reloadButtonPosition === 'right' && buttonElementNode), description && _react["default"].createElement("p", null, description), !reloadAsLink && reloadButtonPosition !== 'right' && _react["default"].createElement("div", {
          style: divStyle
        }, buttonElementNode)), tooltip && _react["default"].createElement(_ElementErrorBoundary.StyledTooltip, {
          id: "tooltip",
          placement: "right",
          target: "section"
        }, tooltipText));
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      console.error('Something went wrong', error);
      return {
        hasError: true
      };
    }
  }]);
  return ElementErrorBoundary;
}(_DatadogErrorBoundary2.DatadogErrorBoundary);
(0, _defineProperty2["default"])(ElementErrorBoundary, "defaultProps", {
  buttonText: 'Reload',
  iconType: 'info',
  reloadIcon: true,
  reloadButtonPosition: 'center',
  tooltipText: 'Something went wrong. Try reloading the content.',
  tooltip: false,
  sectionTextAlign: 'center',
  sectionHeight: 'fit-content',
  sectionWidth: 'fit-content',
  sectionMargin: 'auto',
  reloadAsLink: false
});
var getButtonElement = function getButtonElement(reloadIcon, buttonText, onReload) {
  var buttonIconStyle = {
    width: '12px',
    height: '12px',
    color: '#FFFFFF',
    marginRight: !buttonText ? '0px' : '8px'
  };
  return _react["default"].createElement(_Button.Button, {
    style: {
      fontSize: '12px',
      margin: '0px'
    },
    onClick: onReload,
    color: 'destructive'
  }, reloadIcon && _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    style: buttonIconStyle,
    icon: _freeSolidSvgIcons.faRedo
  }), buttonText);
};
var getLinkElement = function getLinkElement(buttonText, header, onReload) {
  return _react["default"].createElement(_ElementErrorBoundary.StyledLink, {
    style: {
      marginLeft: !header ? '0px' : '8px'
    },
    onClick: onReload
  }, buttonText);
};
ElementErrorBoundary.propTypes = {
  header: _propTypes["default"].string,
  description: _propTypes["default"].string,
  buttonText: _propTypes["default"].string,
  iconType: _propTypes["default"].string,
  reloadIcon: _propTypes["default"].bool,
  reloadButtonPosition: _propTypes["default"].string,
  tooltipText: _propTypes["default"].string,
  tooltip: _propTypes["default"].bool,
  sectionTextAlign: _propTypes["default"].string,
  sectionHeight: _propTypes["default"].string,
  sectionWidth: _propTypes["default"].string,
  sectionMargin: _propTypes["default"].string,
  reloadAsLink: _propTypes["default"].bool,
  onReload: _propTypes["default"].func
};